import * as React from "react";
const SvgThinArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 46, height: 27, viewBox: "0 0 46 27", style: {
  transform: "rotate(180deg)"
}, ...props }, /* @__PURE__ */ React.createElement("g", { style: {
  fillRule: "evenodd",
  fill: "none",
  strokeLinecap: "round"
} }, /* @__PURE__ */ React.createElement("g", { style: {
  strokeWidth: 4,
  stroke: "#3E5B77"
} }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-1305 -556)translate(1076 547)translate(230 9)" }, /* @__PURE__ */ React.createElement("line", { x1: 27.7, y1: 7.9, x2: 45.3, y2: 7.1, transform: "translate(36.5 7.5)rotate(45)translate(-36.5 -7.5)" }), /* @__PURE__ */ React.createElement("line", { x1: 28.5, y1: 19.5, x2: 45.5, y2: 19.5, transform: "translate(37 19.5)rotate(-45)translate(-37 -19.5)" }), /* @__PURE__ */ React.createElement("line", { y1: 13.5, x2: 41, y2: 13.5 })))));
export default SvgThinArrowLeft;
